<rid-odd-one-out
  class="h-dvh"
  [questions]="[{ id: '1', question: 'Welk woord past er niet bij?', options: ['appel', 'prei', 'banaan', 'kaki'], answer: 2 }]"
  (finished)="$router.navigate(['/mechanics/sorting/odd-one-out'])"
/>
